import { Query } from '../../generated/graphql';
import { ApolloClient, gql } from '@apollo/client/core';
import * as Report from './Report';

const FETCH_LOOKER_REPORT = gql`
  query LookerReports($reportId: String!) {
    app {
      lookerReportLink(reportId: $reportId)
    }
  }
`;

const FETCH_ALL_REPORTS = gql`
  query LookerReports {
    app {
      lookerReports {
        name
        reportId
      }
    }
  }
`;

export const fetchSelectedReportLink = async (client: ApolloClient<Query>, reportId: string) => {
  const { data } = await client.query({
    query: FETCH_LOOKER_REPORT,
    variables: { reportId },
    fetchPolicy: 'network-only',
  });

  if (!data.app.lookerReportLink) {
    throw Error('Error fetching report');
  }

  return data.app.lookerReportLink;
};

export const fetchAllReports = async (client: ApolloClient<Query>): Promise<Report.Report[]> => {
  const { data } = await client.query({
    query: FETCH_ALL_REPORTS,
  });

  if (!data.app.lookerReports) {
    throw Error('Error fetching reports');
  }

  return Report.fromGqlCollection(data.app.lookerReports);
};
